module.exports = __webpack_public_path__ + "assets/eth-icon.b65cc783.svg";